module.exports = __webpack_public_path__ + "img/xiajiang.fbfdd47c.png";